'use client';

import { useProfile } from '@/components/providers/profile-provider';
import { TabNavigation } from '@/components/tab-navigation';
import { Button } from '@/components/ui/button';
import { useIsMobile } from '@/hooks/use-mobile';
import { Search } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import * as React from 'react';
import { profileTabs } from '../utils/constants';
import PurchasedBatchCard from './purchased-batch-card';
export function PurchasedBatches({
  onClose
}: {
  onClose?: () => void;
}) {
  const isMobile = useIsMobile();
  const {
    purchasedBatches
  } = useProfile();
  return <div className="relative flex w-full flex-col" data-sentry-component="PurchasedBatches" data-sentry-source-file="purchased-batches.tsx">
      {isMobile && <TabNavigation tabs={profileTabs} activeTab="My batches" className="sticky top-20 z-10 md:static" />}
      <div className="flex w-full flex-col items-center gap-2 px-5 py-3 pb-24">
        {purchasedBatches && purchasedBatches.length > 0 ? purchasedBatches.map(batch => <PurchasedBatchCard key={batch.id} title={batch.title} bannerImage={`${batch.banners[0].resourceId}`} endDate={batch.batchDuration.to} location={batch.branch?.name as string} batch={batch.number} status={batch.own?.status ?? 'Pending'} />) : <div className="mt-16 flex w-full max-w-md flex-col gap-8 rounded-lg  px-7   text-center">
                <div className="mb-4 flex w-full justify-center">
                  <Image src="/not-found.svg" height={142} width={160} alt="Batch not found">

                  </Image>
                </div>
                <div>
                  <h2 className="mb-2 text-xl font-semibold text-gray-800">
                    No batches found!
                  </h2>
                  <p className="mb-4 text-gray-600">
                    Let’s find the perfect batch for you!.
                    Click the below button to explore batches
                  </p>
                </div>
                <div className="flex justify-center">
                  <Link href="/batchfinder" onClick={onClose}>
                    <Button className="w-fit active:bg-blue-600">
                      <Search />
                      {' '}
                      Explore batches
                    </Button>
                  </Link>
                </div>
              </div>}
        {/* <WhatsappSupport /> */}
      </div>
    </div>;
}